export default "__VITE_ASSET__BRda_coJ__"